// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container___YK2ao{padding-top:var(--made-space-16-x);padding-bottom:var(--made-space-16-x);text-align:center}\n", "",{"version":3,"sources":["webpack://./src/components/RulesHeader/ScheduledDeploymentModal/content/IsLoading.css"],"names":[],"mappings":"AAAA,mBACI,kCAAA,CACA,qCAAA,CACA,iBAAA","sourcesContent":[".container {\n    padding-top: var(--made-space-16-x);\n    padding-bottom: var(--made-space-16-x);\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container___YK2ao"
};
export default ___CSS_LOADER_EXPORT___;
